import { Alert, Button, Typography } from "@dealer-center/core-components";
import { MessagePage } from "@dealer-center/core-custom-components";
import { Outlet } from "react-router-dom";

const validSystemPaths = ["landing", "autotrader"];
export const needAuthMessage =
  "No authentication found. Redirecting to CC-Session/Common Signin...";
export const needCookieMessage =
  "Successful return from Session. Redirecting to cookie-creation service.";
export const authErrorMessage = "Error validating JWT";
export const validatingAuthMessage = "Validating jwt";

// Default redirect implementation
export const defaultRedirect = (url: string) => {
  window.location.href = url;
};

export function handleSessionExpired(
  redirectFn = defaultRedirect,
  message = "Session expired"
) {
  const url = window.location.href;
  return (
    <>
      <Alert type="caution">
        <Typography variant="h2">{message}</Typography>
        <Button
          buttonStyle="primary"
          onClick={() => {
            redirectFn(url);
          }}
          analyticsConfiguration={{
            eventName: "sessionExpired"
          }}
        >
          Redirect to CC-Session/Common Signin
        </Button>
      </Alert>
      <Outlet />
    </>
  );
}

export function handleNoAuth(redirectFn = defaultRedirect) {
  const callbackUrl = getCallbackUrl();
  const currentURL = new URL(window.location.href);
  setInitialUrlCookie(currentURL);
  setTimeout(() => redirectFn(callbackUrl), 100);
  const message = needAuthMessage;
  return <MessagePage actionName="auth-noauth" message={message} />;
}

function setInitialUrlCookie(currentURL: URL) {
  document.cookie = `ddc-initialurl=${encodeURIComponent(
    currentURL.href
  )};path=/`;
}

export function handleJwt(jwt: string, redirectFn = defaultRedirect) {
  const cc9Path = getCc9Path();
  const url = getCookieCreatiinUrl(cc9Path, jwt);
  setTimeout(() => redirectFn(url), 100);
  const message = needCookieMessage;
  return <MessagePage actionName="auth-needcookie" message={message} />;
}

function getCallbackUrl() {
  const cc9Path = getCc9Path();
  const controlCenterUrl = getControlCenterUrl();
  const callback = new URL(`${cc9Path}?__jwt_session={auth_jwt}`);
  const url = `${controlCenterUrl}session/JwtSession?callback=${encodeURIComponent(
    callback.toString()
  )}&idp=`;
  return url;
}

function getControlCenterUrl() {
  const currentURL = new URL(window.location.href);
  const controlCenterUrl = `https://${currentURL.hostname}/`;
  return controlCenterUrl;
}

function getCc9Path() {
  const systemPath = getSystemPath();
  const controlCenterUrl = getControlCenterUrl();
  const cc9Path = `${controlCenterUrl}${systemPath}/`;
  return cc9Path;
}

function getSystemPath() {
  const pathSegments = window.location.pathname.split("/");
  const systemPath =
    pathSegments[1] && pathSegments[1].trim() !== ""
      ? pathSegments[1]
      : validSystemPaths[0];
  if (!validSystemPaths.includes(systemPath)) return validSystemPaths[0];
  return systemPath;
}

export function handleAuthError() {
  return <MessagePage actionName="auth-error" message={authErrorMessage} />;
}

export function handleUserLoading() {
  return (
    <MessagePage
      actionName={"Loading user state"}
      message="Loading user information"
    />
  );
}

export function handlePendingValidation() {
  const message = validatingAuthMessage;
  return <MessagePage actionName="auth-validating" message={message} />;
}

function getCookieCreatiinUrl(cc9Path: string, jwt: string) {
  return `${cc9Path}nxlambda/login?callback=${encodeURIComponent(
    `${cc9Path}`
  )}&__jwt_session=${jwt}`;
}
